if (!window.Promise) {
  // webpack will split these into separate scripts if necessary
  // these are necessary for submitting the form
  import(/* webpackChunkName: "polyfill-promise" */ 'promise-polyfill');
  import(/* webpackChunkName: "polyfill-fetch" */ 'whatwg-fetch');
}

if (!window.Set) {
  // react depends on this
  import(/* webpackChunkName: "es-set" */ 'core-js/es/set');
}

if (!window.Map) {
  // react depends on this
  import(/* webpackChunkName: "es-map" */ 'core-js/es/map');
}

if (!window.requestAnimationFrame) {
  // react depends on this
  import(/* webpackChunkName: "raf" */ 'raf/polyfill');
}
